import { Form, FormikProps, withFormik, getIn, validateYupSchema } from "formik";
import * as React from "react";
import { IFormValues } from "src/Interfaces/FormValues";
import {IncorporationSchema} from "./forms/validationSchema";
import Start from "./3a.01";
import Step1 from "./3a.02";
import Step2 from "./3a.03";
import Step3 from "./3a.04";
import Step4 from "./3a.05";
import Step5 from "./3a.06";
import Summary from "./forms/Summary";
import Step6 from "./3a.07";
import Step7 from "./3a.08";
import Breadcrumbs from "./forms/partials/Breadcrumbs";
import Checkout from "src/containers/Checkout";
import { Modal, ModalHeader, ModalBody, Alert } from "reactstrap";
import Pricing from "./forms/partials/Pricing";
import { Link } from "gatsby";

interface IFormProps {
    type: string;
    paymentAmount: number;
    name: string;
    initialEmail?: string;
    message?: string; // if this passed all the way through you might do this or make a union type
}

interface IFormState {
    step: number;
    modal: boolean;
    visible: boolean;
    left_shares: number;
    allDone:boolean;
}

class FormWizard extends React.Component<FormikProps<IFormValues> & IFormProps, IFormState> {
    constructor(props: FormikProps<IFormValues> & IFormProps) {
        super(props);

        this.state = {
            step: 0,
            modal: false,
            visible: true,
            left_shares: 0,
            allDone: false
        };

        // console.log(props)

        this.onDismiss = this.onDismiss.bind(this);
    }

    public setAllFieldsTouched = (key: string) => {
        const currentObj = (this.props.values as any)[key];

        Object.keys(currentObj).map((value, index) => {
            this.props.setFieldTouched(`${key}.${value}`);
        });
    };
    public nextStep = () => {
        this.setState({
            step: this.state.step + 1
        });
    };

    public handlePath = (nextStep: number) => {
        this.setState({
            step: nextStep
        });
    };

    // public setShareholderValues = (data: any) => {
    //     this.props.setValues({
    //         ...this.props.values,
    //         shareholders: data
    //     });
    // };

    // public setDirectorValues = (data: any) => {
    //     this.props.setValues({
    //         ...this.props.values,
    //         director: data
    //     });
    // };

    public componentDidMount = () => {
        // this.setState({
        //     left_shares: this.props.values.shares.number
        // });
        this.props.validateForm();
    };

    public back = () => {
        this.setState({
            step: this.state.step - 1
        });
    };

    public handleCheckout = () => {
        let error = false;
        
        if (getIn(this.props.errors, "personal")) {
            this.setAllFieldsTouched("personal");
            error = true
        }

        if (getIn(this.props.errors, "company")) {
            this.setAllFieldsTouched("company");
            error = true
        }

        if (error) {
            return;
        }

        this.toggle();
        this.props.submitForm();
    };

    public toggle = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    };

    public onDismiss = () => {
        this.setState({ visible: false });
    };

    public UpdateShares = (occupied: number) => {
        // const total = this.props.values.shares.number - occupied;
        // this.setState({
        //     left_shares: total
        // })
    }

    public componentWillReceiveProps = (
        nextProps: FormikProps<IFormValues>
    ) => {
        if (!!nextProps.status && !!nextProps.status.success) {
            this.setState(
                {
                    step: 0
                },
                () => {
                    window.scrollTo({
                        top: 0
                    });
                }
            );

            // setTimeout(() => this.props.resetForm(), 3000);
        }
    };

    public render() {
        const { step } = this.state;
        // tslint:disable-next-line:jsx-key
        const props = {
            ...this.props,
            setAllFieldsTouched: this.setAllFieldsTouched
        };
        const allPaths = [
            "Start",
            "Personal Information",
            "Company Information",
            "Share Formation",
            "Shareholder Information",
            "Director Information",
            "Company Secretary",
            "Others",
            "Summary",
            "Pricing"
        ];

        const steps = [
            <Step1
                key="Step1"
                {...props}
                nextStep={this.nextStep}
                back={this.back}
            />,
            <Step2
                key="Step2"
                {...props}
                nextStep={this.nextStep}
                back={this.back}
            />,
        ];

        const { type, paymentAmount, status  } = this.props;
        // console.log(this.props.name)
        return (
            <section className="my-5" id="incorporation-form">
                <div className="container">
                    <div className={`incorp-loader ${this.props.isSubmitting ? 'd-flex': 'd-none'}`}>
                        Processing your data <span className="animate-flicker">&nbsp;...</span>
                    </div>

                    {
                        this.state.allDone && <div className={`incorp-loader d-flex`}>
                            <div className="text-align">
                                Company Incorporation is now in progress! <br />We shall contact you soon on the rest of the documents.<br /><br />
                                <Link to="/">Back to Home</Link>
                            </div>
                        </div>
                    }

                    {!!status && !!status.success ? (
                        <Alert
                            color="info"
                            isOpen={this.state.visible}
                            toggle={this.onDismiss}
                        >
                            Company Incorporation is now in progress! We shall contact you soon on the rest of the documents.
                            <Link to="/">Back to Home</Link>
                        </Alert>
                    ) : (
                        ""
                    )}

                    {!!status && !!status.error ? (
                        <Alert
                            color="danger"
                            isOpen={this.state.visible}
                            toggle={this.onDismiss}
                        >
                            Company Incorporation Failed!
                        </Alert>
                    ) : (
                        ""
                    )}
                    <Form>
                        {steps}
                        <button 
                            type="button" 
                            className="btn btn-warning mx-auto" 
                            onClick={this.handleCheckout}
                        >
                            Submit
                        </button>
                    </Form>
                    <Modal isOpen={this.state.modal} backdrop={true}>
                        <ModalHeader
                            className="text-center"
                        >
                            Checkout
                        </ModalHeader>
                        <ModalBody>
                            <Checkout
                                paymentAmount={paymentAmount}
                                paymentType={type}
                                name={this.props.values.personal.firstname + this.props.values.personal.lastname}
                                email={this.props.values.personal.email}
                                onSuccess={() => this.setState({allDone: true, modal: false})}
                                close={() => this.setState({ modal: false})}
                            />
                        </ModalBody>
                    </Modal>
                </div>
            </section>
        );
    }
}

const MasterForm = withFormik<IFormProps, IFormValues>({
    mapPropsToValues: (props) => {
        return {
            company: {
                companyname_1: "",
                companyname_2: "",
                nature_of_business: "",
                address: "",
                country: ""
            },
            personal: {
                country_code: "852",
                email: "",
                phone: "",
                firstname: "",
                lastname: ""
            },
            package: props.type,
        };
    },
    validationSchema: IncorporationSchema,

    handleSubmit: async (values, { setSubmitting, setStatus }) => {
        try {
            setSubmitting(true);

            const res = await fetch(
                `${process.env.GATSBY_API_URL}/registration`,
                {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json"
                    },
                    body: JSON.stringify({
                        ...values
                    })
                }
            );
            setSubmitting(false);

            if (res.status === 200) {
                setStatus({ success: "form submited" });
            } else {
                setStatus({ error: "form not submited" });
            }

        } catch (e) {
            // tslint:disable-next-line:no-console
            console.log(e);
            setSubmitting(false);

            setStatus({ error: "form not submited" });
        }
    }
})(FormWizard);

export default MasterForm;
